import { ProductDetailsEnum } from '../enums/inventory-table-columns.enum';
import { ProductDetailsConfig } from '../interfaces/column-config.interface';
import { BASE_CELL_CLASS, BASE_HEADER_CLASS } from './table-style.constants';

export const FAKE_PODUCT_DETAILS_QUANTITY = 5;
const INVENTORY_PRODUCT_DETAILS_TABLE = 'inventory.productDetails.table';

export const PRODUCT_DETAILS_COLUMNS_CONFIG: readonly ProductDetailsConfig[] = [
  {
    name: ProductDetailsEnum.NAME,
    label: `${INVENTORY_PRODUCT_DETAILS_TABLE}.name`,
    headerClass: BASE_HEADER_CLASS,
    cellClass: `${BASE_CELL_CLASS} ${BASE_CELL_CLASS}--name`,
  },
  {
    name: ProductDetailsEnum.TYPE,
    label: `${INVENTORY_PRODUCT_DETAILS_TABLE}.type`,
    headerClass: BASE_HEADER_CLASS,
    cellClass: BASE_CELL_CLASS,
  },
  {
    name: ProductDetailsEnum.UNIT,
    label: `${INVENTORY_PRODUCT_DETAILS_TABLE}.unit`,
    headerClass: BASE_HEADER_CLASS,
  },
  {
    name: ProductDetailsEnum.VALUE,
    label: `${INVENTORY_PRODUCT_DETAILS_TABLE}.value`,
    headerClass: BASE_HEADER_CLASS,
  },
];
